import { DestroyRef, Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';
import { ROUNDNESS_LEVEL_CLASSES_MAP, SETTINGS_SERVICE } from '../constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { SettingsRoundnessLevel } from '../models';

@Directive({
  selector: '[roundnessClass]',
  standalone: false
})
export class RoundnessClassDirective implements OnInit {
  private settingsService = inject(SETTINGS_SERVICE);
  private roundnessLevelMap = inject(ROUNDNESS_LEVEL_CLASSES_MAP);
  private destroyRef = inject(DestroyRef);
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);

  ngOnInit(): void {
    this.settingsService.getSettings()
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(settings => {
        const roundnessLevel = settings?.branding?.roundnessLevel || 0;
        const baseRoundnessClass = this.roundnessLevelMap[roundnessLevel] ?? this.roundnessLevelMap?.[SettingsRoundnessLevel.SEMI_ROUNDED];

        this.applyClass(baseRoundnessClass);        
      })
  }

  private applyClass(className: string): void {
    this.renderer.addClass(this.el.nativeElement, className);
  }
}
